import { useState,useEffect } from "react";
import { Button, Nav, Navbar } from "react-bootstrap"




const Header = ({current_page}: {current_page: string}) => {
  const  [buttonCaption, setButtonCaption] = useState<string>("");
  useEffect(() => {
    const locoenv = localStorage.getItem("locoEnv");
    if (locoenv == null) {
      localStorage.setItem("locoEnv", "prod");
    }
    setButtonCaption(locoenv ? locoenv : "prod")
  }, []) 

  const setApiEnv = () => {
    switch(localStorage.getItem("locoEnv")) {
      case "prod":
        localStorage.setItem("locoEnv", "stg");
        setButtonCaption("stg")
        break;
      case "stg":
        localStorage.setItem("locoEnv", "prod");
        setButtonCaption("prod")
        break;
      default:
        localStorage.setItem("locoEnv", "prod");
        setButtonCaption("prod")
        break;
    }
  }
  return (
    
    <Navbar expand="lg" bg="dark" variant='dark' style={{ minWidth: 700 }}>
      
      <Navbar.Brand className="font-weight-bold" href="https://loco-tools-portal.bcw-mt.com/">Loco Terminal Track For PositionLog</Navbar.Brand>
      <Nav className='mr-auto'>
        {current_page === "Setting" ? <Nav.Item><Nav.Link href='/Setting' className="active">Home</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/Setting'>Home</Nav.Link></Nav.Item>}
        {current_page === "Tracker" ? <Nav.Item><Nav.Link href='/LogTrack' className="active">Tracker</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/LogTrack'>Tracker</Nav.Link></Nav.Item>}
      </Nav>
      <Button type="button" className="mb-1" title="StagingとProductionを切り替えられます" onClick={() => setApiEnv()}>{buttonCaption === "prod" ? "Production" : "Staging"}</Button>
    </Navbar>
  )
}

export default Header